import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout';
import { uniteData } from '../util/index';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component:Layout,
    children:[{
      path: '/',
      name:'首页',
      component: () => import('../views/Home.vue')
    }],
  },
  {
    path: '/brand',
    component:Layout,
    children:[{
      path: '/brand',
      name: '品牌LOGO设计',
      component: () => import('../views/brand.vue'),
    }],
  },
  {
    path: '/serve',
    component:Layout,
    children:[{
      path: '/serve',
      name: '软件服务',
      component: () => import('../views/serve.vue')
    }],
  },
  {
    path: '/business',
    component:Layout,
    children:[{
      path: '/business',
      name: '电子商务',
      component: () => import('../views/business.vue')
    }],
  },
  {
    path: '/news',
    component:Layout,
    children:[{
      path: '/news',
      name: '动态资讯',
      component: () => import('../views/news.vue')
    }],
  },
  {
    path: '/release',
    component:Layout,
    children:[{
      path: '/release',
      name: '免费发布信息',
      component: () => import('../views/release.vue')
    }],
  },
  {
    path: '/recharge',
    component:Layout,
    children:[{
      path: '/recharge',
      name: '充值中心',
      component: () => import('../views/recharge.vue')
    }],
  },
  {
    path: '/articles/:id',
    component:Layout,
    children:[{
      name:'动态资讯_详情',
      path: '/articles/:id',
      meta:{
        title:'articles',
      },
      component: () => import('../views/articles.vue')
    }],
  },
  {
    path: '/details',
    component:Layout,
    children:[{
      name: '详情',
      meta:{
        title:'details',
      },
      path: '/:details/:id',
      component: () => import("../views/details"),
    }],
  },
  {
    path: '*',
    meta:{
      title:'404页面没找到',
    },
    component: () => import('../views/error')
    // component:Layout,
    // children:[{
    //   name:'404',
    //   path:'*',
    //   component: () => import("../views/error"),
    // }],
  },
]


const router = new VueRouter({
  routes
})

// 全局前置路由守卫
router.beforeEach((to,from,next) => {  //路由守卫
  console.log(uniteData.name,to.name)
  document.title = `${uniteData.name}_${to.name}`;
  next();
})

export default router